export const enum Pages {
  // System
  ROOT = '/',
  AUTH_CALLBACK = '/callback',
  NO_PERMISSIONS = '/wait',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = 'not-found',
  CHANGE_PASSWORD = 'profile/change-password',

  // Основна навігація
  CLIENTS = '/clients',
  COUNTERPARTIES = '/counterparty-clients',
  CONTRACT_CASES = '/contract-cases',
  POTENTIAL = 'potential',
  UNIDENTIFIED = 'unidentified',
  CLIENT_FINANCE = 'finance',
  CONTRACTS_DEBT = 'contracts-debt',
  CLIENT_COMMUNICATION = 'communication',
  CLIENT_APPEALS = 'appeals',
  CLIENT_APPLICATIONS = 'applications',
  CLIENT_SURVEYS = 'surveys',
  CLIENT_TAKE_A_SURVEY = 'take-a-survey',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  APPEALS = 'appeals',
  APPEALS_SETTINGS = 'settings',

  SURVEYS = '/surveys',
  SURVEY_BUILDER = 'builder',
  SURVEY_EDIT = ':id/edit',

  INFORMING = 'informing',
  INFORMING_CAMPAIGN_BUILDER = 'campaign-builder',

  // Співробітники, групи і ролі — former tabs of «Моя організація» (GSB-8540).
  EMPLOYEES = '/employees',
  EMPLOYEE_GROUPS = '/groups',
  ROLES = 'roles',

  // Former paths of the «Моя організація» page, kept only to redirect old links.
  ORGANIZATION = 'organization',
  ADMINISTRATION = 'administration',

  WORKFLOW_BUILDER = '/workflow-builder',
  WORKFLOW_DRAFTS = 'drafts',
  /** Old links to a workflow — redirects to its published version, else the draft. */
  WORKFLOW_DASHBOARD = '/workflow-builder/:workflowId',
  WORKFLOW_VERSION_DASHBOARD = '/workflow-builder/:workflowId/versions/:versionId',
  WORKFLOW_TRANSITIONS = 'transitions',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  WORKFLOW_SETTINGS = 'settings',
  WORKFLOW_SETTINGS_BOARD = 'board',
  WORKFLOW_SETTINGS_AUTOMATION = 'automation',
  WORKFLOW_SETTINGS_GENERAL = 'general',
  WORKFLOWS = '/workflows',
  WORKFLOWS_INSTANCES = 'instances',
  BUSINESS_PROCESSES = 'business-processes',
  BUSINESS_PROCESSES_DOCUMENTS = 'documents',

  TAG_MANAGEMENT = 'tag-management',

  BI_DASHBOARDS = '/bi-dashboards',
  AI_ASSISTANT = '/ai-assistant',

  GENERAL_SETTINGS = '/general-settings',
  CONTRACT_CONCLUSION = '/contract-conclusion',
  INFORMING_SETTINGS = '/informing-settings',
}
